export const SUPPORT_STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "open", label: "Open" },
  { value: "in_progress", label: "In progress" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
];

export const SUPPORT_STATUS_BADGES = {
  open: "border-[rgba(var(--afrimed-primary),0.34)] bg-[rgba(var(--afrimed-primary),0.08)] text-[rgb(var(--afrimed-primary))]",
  in_progress: "border-[rgba(217,119,6,0.34)] bg-[rgba(245,158,11,0.12)] text-amber-700",
  resolved: "border-[rgba(var(--schemes-success),0.35)] bg-[var(--state-success-08)] text-[rgb(var(--schemes-success))]",
  closed: "border-[rgba(var(--clr-outline-variant),0.75)] bg-[var(--state-on-surface-08)] text-on-surface-var",
};

export const SUPPORT_PRIORITY_BADGES = {
  low: "text-on-surface-var",
  medium: "text-[rgb(var(--afrimed-primary))]",
  high: "text-on-surface",
  urgent: "text-[rgb(var(--schemes-critical))]",
};

export function supportStatusBadgeClass(status) {
  return SUPPORT_STATUS_BADGES[status] || SUPPORT_STATUS_BADGES.closed;
}

export function supportPriorityBadgeClass(priority) {
  return SUPPORT_PRIORITY_BADGES[priority] || SUPPORT_PRIORITY_BADGES.low;
}

export function supportStatusButtonClass(status, active = false) {
  const base =
    "h-9 rounded-[10px] border px-3 text-label-medium transition focus:outline-none focus:ring-2 focus:ring-[rgba(var(--afrimed-primary),0.16)] disabled:cursor-default";

  if (status === "resolved") {
    return active
      ? `${base} border-[rgba(var(--schemes-success),0.35)] bg-[var(--state-success-08)] text-[rgb(var(--schemes-success))]`
      : `${base} border-[rgba(var(--clr-outline-variant),0.65)] bg-[rgb(var(--clr-surface-cont-highest))] text-on-surface hover:bg-[var(--state-success-08)]`;
  }

  if (status === "in_progress") {
    return active
      ? `${base} border-[rgba(217,119,6,0.34)] bg-[rgba(245,158,11,0.12)] text-amber-700`
      : `${base} border-[rgba(var(--clr-outline-variant),0.65)] bg-[rgb(var(--clr-surface-cont-highest))] text-on-surface hover:bg-[rgba(245,158,11,0.10)]`;
  }

  if (status === "open") {
    return active
      ? `${base} border-[rgba(var(--afrimed-primary),0.34)] bg-[rgba(var(--afrimed-primary),0.08)] text-[rgb(var(--afrimed-primary))]`
      : `${base} border-[rgba(var(--clr-outline-variant),0.65)] bg-[rgb(var(--clr-surface-cont-highest))] text-on-surface hover:bg-[rgba(var(--afrimed-primary),0.08)]`;
  }

  return active
    ? `${base} border-[rgba(var(--clr-outline-variant),0.75)] bg-[var(--state-on-surface-08)] text-on-surface-var`
    : `${base} border-[rgba(var(--clr-outline-variant),0.65)] bg-[rgb(var(--clr-surface-cont-highest))] text-on-surface hover:bg-[var(--state-on-surface-08)]`;
}
